<script setup lang="ts">
import { Form } from 'vee-validate';

import Button from '@clovyr/bed/components/controls/Button.vue';

interface FormWrapperProps {
  headingText?: string;
  submitLabel?: string;
  theme?: string;
  validationSchema?: Record<string, any>;
  initialValues?: Record<string, any> | undefined;
  keepValues?: boolean;
  reversed?: boolean;
  translucent?: boolean;
  showSubmit?: boolean;
  disabled?: boolean;
}

const props = withDefaults(defineProps<FormWrapperProps>(), {
  headingText: '',
  submitLabel: 'submit',
  theme: 'base',
  reversed: true,
  showSubmit: true,
});

const { headingText, submitLabel, theme } = toRefs(props);

// for accessing methods like `form.setErrors`
const form = useTemplateRef('form');
defineExpose({ form });
</script>

<template>
  <Form
    class="form"
    :class="theme"
    :validation-schema="validationSchema"
    :initial-values="initialValues"
    :keep-values="keepValues"
    ref="form"
  >
    <div v-if="!!headingText" class="form__heading">{{ headingText }}</div>

    <slot name="fields" />
    <slot name="disclaimer" />

    <div class="form__submit" v-if="showSubmit">
      <Button
        ref="submitBtn"
        :label="submitLabel"
        type="submit"
        :reversed="reversed"
        :translucent="translucent"
        :disabled
      />
    </div>
  </Form>
</template>
